import React, { Component } from "react";
import * as PIXI from "pixi.js";
import UIManager from "../../core/components/ui/UiBuilder";
import { withPixiApp } from "@inlet/react-pixi";
import { GJIStore } from "../../gamestore/IStore";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withGameGeneralComponentConfiguration from "./configuration/withgameGeneralComponentPortraitConfiguration";
import { isMobile } from "react-device-detect";
import { configGame, constant } from "../../data/config";
//import { Scrollbox } from 'pixi-scrollbox'
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";

import { actions as applicationActions } from '../../core/reducers/applicationStateReducer'
import { actions as desktopSettingPanelActions } from "../../core/reducers/desktopSettingPanelReducer";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as keyboardListenerActions } from "../../core/reducers/keyboardListenerReducer";
import { actions as reelGridActions } from "../../core/reducers/reelgridStateReducer";
import { actions as desktopSettingPanelGameLevel } from "../../gamereducer/desktopSettingPanelGameLevelReducer";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { actions as introductionActions } from "../../gamereducer/introductionPageReducer";
import { actions as behaviourActions } from "../../gamereducer/behaviourReducer";

import { actions as gameLevelSoundActions } from "../../gamereducer/soundGameLevelReducer";
import { actions as reelsActions } from "../../core/reducers/reelsStateReducer";
import { actions as gridsActions } from "../../core/reducers/gridStateReducer";

interface IStore {
    [x: string]: any;
}
interface IProps {
    [x: string]: any;
}

interface IState {

}

interface IStateToProps {
}

interface IDispatchToProps {
}

class GameGeneralComponentPortrait extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected displayUI: any;
    protected gameGeneralComponentPortrait: any;
    protected gameGeneralComponentContainer: any;
    protected scope: any;
    protected ui_mode: string;
    protected gameGeneralComponentList: Array<any>

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.gameGeneralComponentPortrait = React.createRef();
        this.gameGeneralComponentPortrait = React.createRef();
        this.state = {
            uiElements: [],
            lang: "en",
            langObject: this.props.langObj
        }

        if (isMobile) {
            this.ui_mode = "mobile"
        } else {
            this.ui_mode = "desktop"
        }
        //reel,row
        this.doChangesOnTranslation();
        this.gameGeneralComponentList = []
        this.displayUI = this.props.data.COMPONENTS[0].child.filter(this.checkUiMode.bind(this));
        let heightGap = 150;

        if ((window as any).GAME_INFO.jurisdiction == "uk" || (window as any).GAME_INFO.jurisdiction == "es"
            || (window as any).GAME_INFO.jurisdiction == "de"
            || (window as any).GAME_INFO.jurisdiction == "gr"
            || (window as any).GAME_INFO.jurisdiction == "se") {
            this.displayUI && this.displayUI[1].child.splice(4, 1);
        }
        if ((window as any).GAME_INFO.jurisdiction == "co") {
            this.displayUI && this.displayUI[1].child.splice(3, 1);
        }
        // this.displayUI && this.displayUI[1].child.splice(4, 1);
        this.displayUI && this.displayUI[1].child.map((i: any, index: any) => {

            i.y = heightGap * index
        })
    }
    doChangesOnTranslation() {
        if (this.props.langObj.rulesDescription1) {
            this.props.langObj.rulesDescription1 = this.props.langObj.rulesDescription1.replace("%v", this.props.showRTP + "%");
        }

    }
    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    bindUI() {
        this.addScrollBar();

        //UIManager.getRef("nakliScroll") && (UIManager.getRef("nakliScroll").x = 145);
    }

    addScrollBar() {
        let gameGeneralContent: any = UIManager.getRef("gameGeneralContentPortrait")
        let gameGeneralScrollComponent: any = UIManager.getRef("gameGeneralScrollComponentPortrait")
        const Scrollbox = require('pixi-scrollbox').Scrollbox
        let boxWith, boxWidthSprite;
        if (isMobile) {
            boxWith = 1155;
            boxWidthSprite = 1155;
            if (window.innerWidth < window.innerHeight) {
                boxWith = 1080;
                boxWidthSprite = 1080;
            }
        }
        else {
            boxWith = 800;
        }
        const scrollbox = new Scrollbox({ boxWidth: boxWith, boxHeight: 1400 })
        scrollbox.x = 0;
        scrollbox.y = 300;

        gameGeneralScrollComponent && gameGeneralScrollComponent.addChild(scrollbox)

        // add a sprite to the scrollbox's content
        const sprite = scrollbox.content.addChild(new PIXI.Sprite(PIXI.Texture.WHITE))
        sprite.x = 0;
        //sprite.y = 300;
        sprite.width = boxWidthSprite
        sprite.height = 1500
        isMobile && (sprite.alpha = 0.01);
        sprite.tint = 0x131313
        scrollbox.content.addChild(gameGeneralContent);
        scrollbox.dragScroll = true;
        scrollbox.overflowX = "none";
        // force an update of the scrollbox's calculations after updating the children

        // add the viewport to the stage

        scrollbox.update()
    }

    radioController(currentToggleState: any, nextToggleState: any) {
        UIManager.getRef(currentToggleState) && (UIManager.getRef(currentToggleState).visible = false);
        UIManager.getRef(currentToggleState) && (UIManager.getRef(nextToggleState).visible = true);
    }

    handleEvent = (e: any) => {
        switch (e.target.name) {
            case "crossButton":
                this.props.showDesktopSettingPanelUI(false);
                this.props.setAllButtonEnable();
                return;
            case "introScreenRadioButtonOnPortrait":
                this.props.visibleIntroductionScreen(false);
                this.radioController("introScreenRadioButtonOnPortrait", "introScreenRadioButtonOffPortrait");
                return;
            case "introScreenRadioButtonOffPortrait":
                this.props.visibleIntroductionScreen(true);
                this.radioController("introScreenRadioButtonOffPortrait", "introScreenRadioButtonOnPortrait");
                return;
            case "musicRadioButtonOnPortrait":


                this.props.stopAllSFXSound(true)
                this.radioController("musicRadioButtonOnPortrait", "musicRadioButtonOffPortrait");

                return;
            case "musicRadioButtonOffPortrait":


                this.props.soundLoadStartFunction(true);
                this.props.stopAllSFXSound(false)

                this.props.playingSound(true);
                this.radioController("musicRadioButtonOffPortrait", "musicRadioButtonOnPortrait");

                return;
            case "bgMusic_enablePortrait":

                this.props.playBgSound(false);
                this.props.stopAllBGMSound(true);
                this.radioController("bgMusic_enablePortrait", "bgMusic_disablePortrait");
                return;
            case "bgMusic_disablePortrait":

                this.props.soundLoadStartFunction(true);
                this.props.stopAllBGMSound(false);

                this.props.playingSound(true);
                this.props.playBgSound(true);
                this.radioController("bgMusic_disablePortrait", "bgMusic_enablePortrait");

                return;
            case "displayCoin_enablePortrait":
                this.radioController("displayCoin_enablePortrait", "displayCoin_disablePortrait");
                this.props.setDisplayInCoins(false);
                return;
            case "displayCoin_disablePortrait":

                if (!this.props.disableCoins) {

                    this.radioController("displayCoin_disablePortrait", "displayCoin_enablePortrait");
                    this.props.setDisplayInCoins(true);
                }
                else {
                    UIManager.getRef("displayCoin_disablePortrait").interactive = false;
                }



                return;
            case "switchControl_enablePortrait":

                this.props.setApplicationHandMode("right")
                this.radioController("switchControl_enablePortrait", "switchControl_disablePortrait");
                return;
            case "switchControl_disablePortrait":
                this.props.setApplicationHandMode("left")
                this.radioController("switchControl_disablePortrait", "switchControl_enablePortrait");
                return;
            case "spaceBarToSpinRadioButtonOnPortrait":
                this.props.spaceBarSpin(false);
                this.radioController("spaceBarToSpinRadioButtonOnPortrait", "spaceBarToSpinRadioButtonOffPortrait");
                return;
            case "spaceBarToSpinRadioButtonOffPortrait":
                this.props.spaceBarSpin(true);
                this.radioController("spaceBarToSpinRadioButtonOffPortrait", "spaceBarToSpinRadioButtonOnPortrait");
                return;
            case "turboSpinRadioButtonOnPortrait":
                //this.props.setTurboMode(false);
                this.handleReelSpinType(false);
                this.props.turboToggleButton(false);
                this.radioController("turboSpinRadioButtonOnPortrait", "turboSpinRadioButtonOffPortrait");
                return;
            case "turboSpinRadioButtonOffPortrait":
                //this.props.setTurboMode(true);
                this.handleReelSpinType(true);
                this.props.turboToggleButton(true);

                this.radioController("turboSpinRadioButtonOffPortrait", "turboSpinRadioButtonOnPortrait");
                return;
            default:
                return 'No buttons';
        }
    }

    handleReelSpinType(value: any) {
        if (Number(configGame["SPIN_TYPE"]) === 0) {
            /* const {
                startSpin
            } = this.props;
            startSpin(); */
        } else if (Number(configGame["SPIN_TYPE"]) === 2) {
            const {
                setReelGridTurboMode
            } = this.props;
            setReelGridTurboMode(value);
        } else {
            const {
                setGridTurboMode
            } = this.props;
            setGridTurboMode(value);
        }
    }


    componentDidUpdate() {

    }

    componentDidMount() {
        this.bindUI();



        if (isMobile && window.innerWidth < window.innerHeight) {
            if (this.props.disableCoins) {
                UIManager.getRef("displayCoin_enablePortrait") && (UIManager.getRef("displayCoin_enablePortrait").visible = false);
                UIManager.getRef("displayCoin_disablePortrait") && (UIManager.getRef("displayCoin_disablePortrait").interactive = false);

            }
        }
        if (this.props.displayInCoins) {
            this.radioController("displayCoin_disablePortrait", "displayCoin_enablePortrait");
        } else {
            this.radioController("displayCoin_enablePortrait", "displayCoin_disablePortrait");
        }
        if ((window as any).GAME_INFO.jurisdiction == "uk" || (window as any).GAME_INFO.jurisdiction == "es"
            || (window as any).GAME_INFO.jurisdiction == "de"
            || (window as any).GAME_INFO.jurisdiction == "gr"
            || (window as any).GAME_INFO.jurisdiction == "se") {
            //this.props.handleReelSpinType(false);
            // this.props.turboToggleButton(false);
            // this.radioController("turboSpinRadioButtonOn", "turboSpinRadioButtonOff");
            UIManager.getRef("turboSpinRadioButtonOffPortrait") && (UIManager.getRef("turboSpinRadioButtonOffPortrait").visible = true);
            UIManager.getRef("turboSpinRadioButtonOffPortrait") && (UIManager.getRef("turboSpinRadioButtonOffPortrait").interactive = false);
        }

        if (this.props.handMode === "left") {
            this.radioController("switchControl_disablePortrait", "switchControl_enablePortrait");
        }
        if (this.props.handMode === "right") {
            this.radioController("switchControl_enablePortrait", "switchControl_disablePortrait");
        }
    }
    handleSoundRadioButtons(isSoundPlaying?: any) {
        UIManager.getRef("musicRadioButtonOnPortrait").visible = !isSoundPlaying;
        UIManager.getRef("musicRadioButtonOffPortrait").visible = isSoundPlaying;
    }
    handleBgMusicRadioButtons(isSoundPlaying?: any) {
        if (!isSoundPlaying) {
            this.props.playBgSound(true);
            this.radioController("bgMusic_disablePortrait", "bgMusic_enablePortrait");

        } else {

            this.radioController("bgMusic_enablePortrait", "bgMusic_disablePortrait");

        }
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.displayInCoins !== this.props.displayInCoins
            || nextProps.handMode !== this.props.handMode
        ) {
            return false;
        }
        if (
            nextProps.allSoundSFXStop !== this.props.allSoundSFXStop
            || nextProps.allSoundBGMStop !== this.props.allSoundBGMStop
            || nextProps.displayInCoins !== this.props.displayInCoins
            || nextProps.turboToggle !== this.props.turboToggle
            || nextProps.showGameSettings !== this.props.showGameSettings
        ) {
            if (nextProps.showGameSettings) {
                if (!nextProps.turboToggle) {
                    UIManager.getRef("turboSpinRadioButtonOnPortrait") && (UIManager.getRef("turboSpinRadioButtonOnPortrait").visible = true);
                    UIManager.getRef("turboSpinRadioButtonOffPortrait") && (UIManager.getRef("turboSpinRadioButtonOffPortrait").visible = false);
                }
                else {
                    UIManager.getRef("turboSpinRadioButtonOffPortrait") && (UIManager.getRef("turboSpinRadioButtonOffPortrait").visible = true);
                    UIManager.getRef("turboSpinRadioButtonOnPortrait") && (UIManager.getRef("turboSpinRadioButtonOnPortrait").visible = false);
                }
            }

            if (nextProps.allSoundSFXStop !== this.props.allSoundSFXStop) {

                this.handleSoundRadioButtons(nextProps.allSoundSFXStop);
                if (nextProps.allSoundBGMStop) {
                    nextProps.playingSound(false);
                }
            }
            if (nextProps.allSoundBGMStop !== this.props.allSoundBGMStop) {

                this.handleBgMusicRadioButtons(nextProps.allSoundBGMStop);
                if (nextProps.allSoundSFXStop) {
                    nextProps.playingSound(false);
                }
            }
            return false;
        }
        return true;
    }
    render() {

        return (<UIManager id={"gameGeneralComponentPortrait"} name={"gameGeneralComponentPortrait"} type={"Container"}
            ref={i => this.gameGeneralComponentPortrait = i}
            x={0} y={0}>
            {
                this.displayUI && this.displayUI.map((i: any) =>
                    <UIManager key={`UIManager-${Math.random()}`} ClickHandler={this.handleEvent} langObj={this.props.langObj} type={i.type}
                        id={i.id} {...i} app={this.app} />)
            }
        </UIManager>)
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'desktopSettingPanelGameLevel' | 'soundState' | 'applicationState' | 'wrapperState' | 'behaviourState'>): IStateToProps =>
    ({
        showRTP: state.applicationState.showRTP,
        disableCoins: state.wrapperState.disableCoins,
        displayInCoins: state.behaviourState.displayInCoins,
        handMode: state.applicationState.handMode,
        allSoundSFXStop: state.soundState.allSoundSFXStop,
        allSoundBGMStop: state.soundState.allSoundBGMStop,
        turboToggle: state.desktopSettingPanelGameLevel.turboToggle,
        showGameSettings: state.behaviourState.showGameSettings
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationHandMode: (handmode: string): any => dispatch(applicationActions.setApplicationHandMode(handmode)),
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        showDesktopSettingPanelUI: (showSettingPanel: boolean): any => dispatch(desktopSettingPanelActions.showDesktopSettingPanelUI(showSettingPanel)),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        spaceBarSpin: (spinWithSpaceBar: boolean): any => dispatch(keyboardListenerActions.spaceBarSpin(spinWithSpaceBar)),
        //setTurboMode: (IsTurboMode: any): any => dispatch(reelGridActions.setTurboMode(IsTurboMode)),
        turboToggleButton: (turboToggle: any): any => dispatch(desktopSettingPanelGameLevel.turboToggleButton(turboToggle)),
        fullScreenToggleButton: (fullScreenToggle: any): any => dispatch(desktopSettingPanelGameLevel.fullScreenToggleButton(fullScreenToggle)),
        playingSound: (soundIsPlaying: any): any => dispatch(soundActions.playingSound(soundIsPlaying)),
        stopAllBGMSound: (stopBgSound: any): any => dispatch(soundActions.stopAllBGMSound(stopBgSound)),
        visibleIntroductionScreen: (value: boolean): any => dispatch(introductionActions.visibleIntroductionScreen(value)),
        setDisplayInCoins: (value: boolean): any => dispatch(behaviourActions.setDisplayInCoins(value)),
        soundLoadStartFunction: (soundLoadStart: boolean): any => dispatch(soundActions.soundLoadStartFunction(soundLoadStart)),
        stopAllSFXSound: (stopSfxSound: any): any => dispatch(soundActions.stopAllSFXSound(stopSfxSound)),
        playBgSound: (bgSoundPlay: any): any => dispatch(gameLevelSoundActions.playBgSound(bgSoundPlay)),

        resetReelState: (): any => dispatch(Number(configGame["SPIN_TYPE"]) === 0 && reelsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 1 && gridsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 2 && reelGridActions.resetReelState()),

        //setReelTurboMode: (IsTurboMode: any): any => dispatch(reelsActions.setTurboMode(reelsActions.setTurboMode(IsTurboMode))),
        setReelGridTurboMode: (IsTurboMode: any): any => dispatch(reelGridActions.setTurboMode(IsTurboMode)),
        setGridTurboMode: (IsTurboMode: any): any => dispatch(gridsActions.setTurboMode(IsTurboMode)),

    }))(withGameGeneralComponentConfiguration(GameGeneralComponentPortrait)));